var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "animated fadeIn" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { attrs: { header: "Card title" } }, [
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { attrs: { "show-footer": "" } }, [
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        "
            ),
            _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
              _vm._v("\n          Card footer\n        "),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { attrs: { header: "<i class='fa fa-check'></i> Card with icon" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", [
            _c("div", { attrs: { slot: "header" }, slot: "header" }, [
              _vm._v("\n          Card with switch\n          "),
              _c(
                "label",
                {
                  staticClass:
                    "switch switch-sm switch-text switch-info float-right mb-0",
                },
                [
                  _c("input", {
                    staticClass: "switch-input",
                    attrs: { type: "checkbox" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "switch-label",
                    attrs: { "data-on": "On", "data-off": "Off" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "switch-handle" }),
                ]
              ),
            ]),
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", [
            _c(
              "div",
              { attrs: { slot: "header" }, slot: "header" },
              [
                _vm._v("\n          Card with label\n          "),
                _c(
                  "b-badge",
                  { staticClass: "float-right", attrs: { variant: "success" } },
                  [_vm._v("\n            Success\n          ")]
                ),
              ],
              1
            ),
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", [
            _c(
              "div",
              { attrs: { slot: "header" }, slot: "header" },
              [
                _vm._v("\n          Card with label\n          "),
                _c(
                  "b-badge",
                  {
                    staticClass: "float-right",
                    attrs: { pill: "", variant: "danger" },
                  },
                  [_vm._v("\n            42\n          ")]
                ),
              ],
              1
            ),
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
            ),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              staticClass: "border-primary",
              attrs: { header: "Card outline" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              staticClass: "border-secondary",
              attrs: { header: "Card outline" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              staticClass: "border-success",
              attrs: { header: "Card outline" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "border-info", attrs: { header: "Card outline" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              staticClass: "border-warning",
              attrs: { header: "Card outline" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "border-danger", attrs: { header: "Card outline" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              attrs: { variant: "accent-primary", header: "Card with accent" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              attrs: {
                variant: "accent-secondary",
                header: "Card with accent",
              },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              attrs: { variant: "accent-success", header: "Card with accent" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { attrs: { variant: "accent-info", header: "Card with accent" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            {
              attrs: { variant: "accent-warning", header: "Card with accent" },
            },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { attrs: { variant: "accent-danger", header: "Card with accent" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-primary text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-success text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-info text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-warning text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-danger text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c("b-card", { staticClass: "bg-secondary text-center" }, [
            _c("blockquote", { staticClass: "card-blockquote" }, [
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                ),
              ]),
              _vm._v(" "),
              _c("footer", [
                _vm._v("\n            Someone famous in\n            "),
                _c("cite", { attrs: { title: "Source Title" } }, [
                  _vm._v("Source Title"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-primary", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-success", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-info", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-warning", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-danger", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-md-4" },
        [
          _c(
            "b-card",
            { staticClass: "bg-secondary", attrs: { header: "Card title" } },
            [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }